import { render, staticRenderFns } from "./ViewHistoryReport.vue?vue&type=template&id=79f9ac52"
import script from "./ViewHistoryReport.vue?vue&type=script&lang=js"
export * from "./ViewHistoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports